import React from 'react'
import Icon from '../index'

const ArrowLongLeftIcon = ({ color, size }: any) => (
  <Icon color={color} size={size}>
    <path
      d="M9.14049638,4.2860102 L12.0353395,6.89310549 C12.4537988,7.26996987 13.0967448,7.23809282 13.4772842,6.81536904 C13.855189,6.39557201 13.8172589,5.74519856 13.4038537,5.37288597 L8.83967284,1.26238536 C8.63426816,1.07739793 8.37477499,0.990893877 8.11877778,1.0007568 C7.86278056,0.990893877 7.60328739,1.07739793 7.3978827,1.26238536 L2.83370181,5.37288597 C2.42029668,5.74519856 2.38236657,6.39557201 2.76027134,6.81536904 C3.14081078,7.23809282 3.78375672,7.26996987 4.20221602,6.89310549 L7.09528397,4.28760894 L7.09528397,13.9628717 C7.09528397,14.5341657 7.55312036,14.9879169 8.11789018,14.9879169 C8.68659746,14.9879169 9.14049638,14.5289885 9.14049638,13.9628717 L9.14049638,4.2860102 Z"
      transform="translate(8.118778, 7.993958) scale(-1, -1) rotate(90.000000) translate(-8.118778, -7.993958) "
    />
  </Icon>
)

ArrowLongLeftIcon.propTypes = {
  ...Icon.propTypes,
}

export default ArrowLongLeftIcon
